import React, { FC } from "react";
import CompanyContentTitle from "../CompanyContentTitle";
import CompanySocialsFeedContent from "../../CompanySocialsFeedContent/CompanySocialsFeedContent";
import { IAnyProps } from "../../../Types/Types";

interface IProps {
  company: { team: []; name: string; company_id: string },
  showSocialsFeedSection: Function;
}

const SocialsFeedSection: FC<IProps> = (props: IAnyProps) => {
  const { company, showSocialsFeedSection, setShowSocialsFeedSection } = props;

  return (
    <>
      {/* <CustomModalProvider> */}

      <>
        <CompanyContentTitle title="Socials" />
        <div className="ps-company-content__container">
          <CompanySocialsFeedContent
            company={company}
           setShowSocialsFeedSection={() => null}/>
        </div>
      </>
    </>
  );
};

export default SocialsFeedSection;
